import React from "react"
import myPrilePic from "../../images/Profile1.jpg"
import site from "../../utilty/getURL"
export default function HireMe() {
  return (
    <div class="myCard text-center w-100 mt-4 bg-white p-3 pt-4 pb-4">
      <div class=" ">
        <div className="">
          <img
            class="hireImage "
            src={myPrilePic}
            alt="Shahid ali CEO of ExtraPixels and Founder of Freelacology"
          />
        </div>
        <div class="card-body pt-4 pb-0 pl-3 pr-3">
          <a href={`${site.siteMetadata.siteUrl}/hire-me`}>
            <h5 class="card-title font-weight-bold text-left mt-0 mb-0">
              SHAHID ALI
            </h5>
            <h5 className="text-left mt-0 mb-1 text-dark">
              Software Developer
            </h5>
          </a>
          <p class="card-text1 text-justify mt-0">
            Get in touch if you need Static/Dynamic web application for your
            business, I love building fast and creative websites using modren
            web technologies MERN Stack.
          </p>
          <div>
            <ul className="icons">
              <a href="/hire-me" class="btnHire w-100">
                Hire Me
              </a>
              <li>
                <a href="mailto:shahidedu696@gmail.com">
                  <i class="fa fa-google" aria-hidden="true"></i>
                </a>
              </li>

              <li>
                <a href="https://twitter.com/ShahidAli696">
                  <i class="fa fa-twitter" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a href="https://github.com/Shahidedu696">
                  <i class="fa fa-github" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/shahid-ali-653121198/">
                  <i class="fa fa-linkedin" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
